import { render, staticRenderFns } from "./setorgmodal.vue?vue&type=template&id=2e69715c&scoped=true&"
import script from "./setorgmodal.vue?vue&type=script&lang=js&"
export * from "./setorgmodal.vue?vue&type=script&lang=js&"
import style0 from "./setorgmodal.vue?vue&type=style&index=0&id=2e69715c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e69715c",
  null
  
)

export default component.exports